import React from 'react';
import {observer} from 'mobx-react';
import classNames from 'classnames';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {getRootStore} from '../../app.bootstrap';
import {requireImage} from '../../utils/utils';

import './styles.scss';

export interface IRecordingIndicatorProps {
    /** Renders the light "Recording" pill used by the mini dashboard instead of the default REC badge */
    pill?: boolean;
    label?: string;
}

@observer
export class RecordingIndicator extends TechseeBaseComponent<IRecordingIndicatorProps> {
    translate = getRootStore().localizationService.translate;

    renderInternal(): JSX.Element {
        const {pill, label} = this.props;

        return (
            <div className={classNames('recording-indicator-container', {pill})}>
                {pill ? (
                    <img className='dot' src={requireImage('mini-dashboard/recording-dot.png')} alt='' />
                ) : (
                    <span className='dot'></span>
                )}
                <span className='rec-title'>
                    {label || this.translate('REACT.DASHBOARD.VIEW.RECORDING_INDICATOR.TITLE')}
                </span>
            </div>
        );
    }
}
